<app-nav-bar/>
<app-hero-promotions/>
<app-promotions-list/>
<app-footer-persona/>1
<app-float-button/>
